export enum DurationType {
  Hour = 'HOUR',
  HourAndHalf = 'HOUR_AND_HALF',
}
